import type { BrowserWindow } from '@wix/thunderbolt-symbols'

// Frozen only during a drag: at rest `1cqw` resolves against each element's own query container, which one px
// value cannot reproduce.
export const DRAG_GAP_MS = 500
export const SETTLE_MS = 150

export const thawSpxUnit = (document: Document) => {
	document.documentElement.style.removeProperty('--one-unit')
}

export const freezeSpxUnitDuringResize = (window: NonNullable<BrowserWindow>): (() => void) => {
	const { document } = window
	let lastWidth = window.innerWidth
	let lastFrameAt = -Infinity
	let frozen = false
	let settleTimer: number | undefined

	const unfreeze = () => {
		frozen = false
		thawSpxUnit(document)
	}
	const settle = () => {
		unfreeze()
		// Sizes changed without a resize, so code that measures on resize would keep stale positions.
		window.dispatchEvent(new Event('resize'))
	}
	const onFrameDrawn = () => {
		lastFrameAt = window.performance.now()
		if (frozen) {
			window.clearTimeout(settleTimer)
			settleTimer = window.setTimeout(settle, SETTLE_MS)
		}
	}

	const onResize = () => {
		const width = window.innerWidth
		if (width === lastWidth) {
			return
		}
		if (!frozen && window.performance.now() - lastFrameAt < DRAG_GAP_MS) {
			frozen = true
			document.documentElement.style.setProperty('--one-unit', `${width / 100}px`)
		}
		lastWidth = width
		window.clearTimeout(settleTimer)
		// Timed from the drawn frame, not the event, so a slow frame neither ends a freeze nor hides a drag.
		window.requestAnimationFrame(() => window.setTimeout(onFrameDrawn))
	}
	window.addEventListener('resize', onResize)

	return () => {
		window.removeEventListener('resize', onResize)
		window.clearTimeout(settleTimer)
		unfreeze()
	}
}
